import { FuseLoadable } from '@fuse';

const ProcessedFluidRapidTest = {
    auth: ['admin', 'sub-admin'],
    routes: [
        {
            exact: true,
            path: '/processed-fluid/rapid-test',
            component: FuseLoadable({
                loader: () => {
                    return import('./ProcessedFluidRapidTestApp');
                },
            }),
        },
    ],
};

export default ProcessedFluidRapidTest;
